
<!-- TABELA -->
<nz-table
  [nzData]="messages"
  [nzLoading]="loading"
  [nzFrontPagination]="false"
  [nzTotal]="total"
  nzSize="small" 
  [nzBordered]="true"
  [nzPageIndex]="pageIndex"
  [nzPageSize]="pageSize"
  [nzTableLayout]="'fixed'"
  (nzQueryParams)="onQueryParamsChange($event)" 
  [nzScroll]="{ y: 'calc(100vh - 430px)'}"
  #nzTable
>
  <thead>
    <tr>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="sessionId">{{'agentBuilder.sessionId'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.sessionId"
          (nzVisibleChange)="onFilterVisibleChange('sessionId', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuTexto">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="dataHoraInicial">{{'agentBuilder.dataHoraInicial'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.dataHoraInicial"
          (nzVisibleChange)="onFilterVisibleChange('dataHoraInicial', $event,true)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuDate">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter nzShowSort [nzSortFn]="true" nzColumnKey="dataHoraFinal">{{'agentBuilder.dataHoraFinal'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.dataHoraFinal"
          (nzVisibleChange)="onFilterVisibleChange('dataHoraFinal', $event,true)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuDate">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="totalRounds">{{'agentBuilder.totalRounds'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.totalRounds"
          (nzVisibleChange)="onFilterVisibleChange('totalRounds', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="totalMessages">{{'agentBuilder.totalMessages'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.totalMessages"
          (nzVisibleChange)="onFilterVisibleChange('totalMessages', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="totalPromptToken">{{'agentBuilder.totalPromptToken'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.totalPromptToken"
          (nzVisibleChange)="onFilterVisibleChange('totalPromptToken', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="totalCompletionTokens">{{'agentBuilder.totalCompletionTokens'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.totalCompletionTokens"
          (nzVisibleChange)="onFilterVisibleChange('totalCompletionTokens', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
      <th nzCustomFilter  nzWidth="100px" nzShowSort [nzSortFn]="true" nzColumnKey="totalTokens">{{'agentBuilder.totalTokens'|translateTA}}
          <nz-filter-trigger
          [(nzVisible)]="visible.totalTokens"
          (nzVisibleChange)="onFilterVisibleChange('totalTokens', $event)"
          [nzActive]="nzTable.data.length > 0"
          [nzDropdownMenu]="menuNumber">
              <nz-icon nzType="search" />
          </nz-filter-trigger>
      </th>
    </tr>
  </thead>

  <tbody>
    @for (data of nzTable.data; track data.sessionId) {
    <tr (dblclick)="openMessageLogDetail(agent,data.sessionId)" style="cursor: pointer;">
      <td nzEllipsis [nzTooltipTitle]="data.sessionId" nz-tooltip>{{ data.sessionId }}</td>
      <td nzEllipsis [nzTooltipTitle]="data.dataHoraInicial" nz-tooltip>{{ data.dataHoraInicial }}</td>
      <td nzEllipsis [nzTooltipTitle]="data.dataHoraFinal" nz-tooltip>{{ data.dataHoraFinal }}</td>
      <td>{{ data.totalRounds }}</td>
      <td>{{ data.totalMessages }}</td>
      <td>{{ data.totalPromptToken }}</td>
      <td>{{ data.totalCompletionTokens }}</td>
      <td>{{ data.totalTokens }}</td>
    </tr>
    
     }
  </tbody>
</nz-table>



<nz-dropdown-menu #menuTexto="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchData[activeColumnKey]" >
          <button nz-button nzSize="small" nzType="primary" (click)="search(activeColumnKey)" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset(activeColumnKey)" class="search-button">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>
<nz-dropdown-menu #menuNumber="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <input type="number" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchData[activeColumnKey]" >
          <button nz-button nzSize="small" nzType="primary" (click)="search(activeColumnKey)" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset(activeColumnKey)" class="search-button">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>
<nz-dropdown-menu #menuDate="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <nz-date-picker
            [ngModel]="activeDateValue"
            (ngModelChange)="onDateSelected($event, activeColumnKey)"
            [style.width.%]="100"
            [nzShowTime]="true"
            [nzFormat]="'yyyy-MM-dd HH:mm:ss'"
            [nzSize]="'default'"
            nzShowToday
            nzShowNow>
          </nz-date-picker>
          <button nz-button nzSize="small" nzType="primary" (click)="search(activeColumnKey)" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset(activeColumnKey)" class="search-button">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>